export const contactSettingState = {
    errorCode : 0,
    statusCode : 0,
    allSetting : [],
    message : '',
    responseValue : ''
}